import getConfig from 'next/config';

const { publicRuntimeConfig: features } = getConfig();

// Client side
const stdPLPFetcher = (...args) =>
  fetch(...args)
    .then((r) => {
      if (r.ok) {
        return r.json();
      }
      if (r.status === 404) {
        return { error: 404 };
      }
      console.error(
        `Quick View fetch: An unexpected response ${r.status} has occurred ${args[0]}`
      );
      throw new Error('An unexpected response has occurred');
    })
    .catch((e) => {
      console.error(`Quick View fetch: An unexpected error has occurred`, e);
      throw new Error(e);
    });

export const PATH_QUICK_VIEW = `${features.applicationPrefix}/api/quick-view`;

export const fetchQuickView = (id) => stdPLPFetcher(`${PATH_QUICK_VIEW}/${id}`);
